var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caseMessage"},[_c('div',{staticClass:"caseMessage_main"},[_c('div',{staticClass:"caseMessage_main_con",domProps:{"innerHTML":_vm._s(_vm.caseMessage.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }